
import imagePath from "../assets/img/icon/login.png"
export default {
    login: {
        imagePath,
        desc: "新华金融舆情数字平台"
    },
    navBarTitle:"新华金融舆情数字平台",
    email:"hefan@news.cn",
    reportTip: "温馨提示：本报告的数据来自新华数字舆情支持，若对报告内容有任何问题，可与客服(Email:hefan@news.cn)联系，谢谢！"

}
